export default __webpack_public_path__ + "static/media/News & Announcements.efb803b6.svg";